import styled from "styled-components";

export const TableCustom = styled.div`
  &.loading {
    padding: 20px 0;
  }
  &.light {
    .ant-table {
      color: #000 !important;
      .ant-table-placeholder,
      .ant-table-placeholder:hover td {
        .ant-empty-description {
          color: #000 !important;
        }
      }
    }
    .ant-table-container {
      .ant-table-cell {
        color: #000;
        &::before {
          background-color: #000 !important;
        }
      }
    }
    .ant-pagination-item-link {
      svg {
        path {
          fill: #000;
        }
      }
    }
    .ant-pagination-item {
      &:hover {
        background-color: rgba(138, 138, 138, 0.4) !important;
        a {
          color: #000;
        }
      }
      &.ant-pagination-item-active {
        background-color: rgba(138, 138, 138, 0.4);
      }
    }
  }

  .ant-table {
    background-color: transparent;
    color: #fff;
    .ant-table-placeholder,
    .ant-table-placeholder:hover td {
      background-color: transparent !important;
      .ant-empty-description {
        color: #fff !important;
      }
    }
  }
  .ant-table-container {
    .ant-table-cell {
      background-color: transparent;
      color: #fff;
      text-align: center;
      border-bottom: 0;
    }
    .ant-table-cell-row-hover {
      background-color: transparent !important;
    }
  }
  .ant-pagination-item-link {
    svg {
      path {
        fill: #fff;
      }
    }
  }

  .ant-pagination-item {
    border: 0;
    background-color: #e84142;
    &:hover {
      background-color: #e84142 !important;
    }
    &.ant-pagination-item-active {
      background-color: #fff;
      a,
      a:hover {
        color: #000;
      }
    }
    a,
    a:hover {
      color: #fff;
    }
  }
`;
